var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4271_3338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 7.5C2.5 4.5 4.8 3 7.5 3C10.2 3 12.5 4.5 14 7.5C12.5 10.5 10.2 12 7.5 12C4.8 12 2.5 10.5 1 7.5Z",
    stroke: "#99A1AF",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.49995 9.3002C8.49406 9.3002 9.29995 8.49431 9.29995 7.5002C9.29995 6.50608 8.49406 5.7002 7.49995 5.7002C6.50584 5.7002 5.69995 6.50608 5.69995 7.5002C5.69995 8.49431 6.50584 9.3002 7.49995 9.3002Z",
    stroke: "#99A1AF",
    strokeWidth: 1.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4271_3338"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.1001bd9c3d876738e39787eba5c82a9e.svg";
export { ForwardRef as ReactComponent };